module.exports = __webpack_public_path__ + "ambient.mp3?1c2220284cd63a5dfa57ba014535461d";


//////////////////
// WEBPACK FOOTER
// ./src/kits/1/sounds/ambient.mp3
// module id = 475
// module chunks = 0